var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.92941 10.5817C1.8878 10.2256 1.867 10.0476 1.87575 9.90089C1.92166 9.13162 2.48897 8.49413 3.24771 8.35923C3.39245 8.3335 3.57167 8.3335 3.9301 8.3335H12.7365C13.095 8.3335 13.2742 8.3335 13.4189 8.35923C14.1776 8.49413 14.745 9.13162 14.7909 9.90089C14.7996 10.0476 14.7788 10.2256 14.7372 10.5817L14.4033 13.4384C14.2526 14.7276 13.5637 15.893 12.5068 16.6466C11.728 17.2018 10.7955 17.5002 9.83909 17.5002H6.82753C5.87114 17.5002 4.93858 17.2018 4.15985 16.6466C3.10293 15.893 2.41401 14.7276 2.26332 13.4384L1.92941 10.5817Z",
    stroke: "#1C274C",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 14.1665H15.8334C17.2141 14.1665 18.3334 13.0472 18.3334 11.6665C18.3334 10.2858 17.2141 9.1665 15.8334 9.1665H14.5834",
    stroke: "#1C274C",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33346 1.6665C7.87322 2.12674 7.87322 2.87293 8.33346 3.33317C8.7937 3.79341 8.7937 4.5396 8.33346 4.99984",
    stroke: "#1C274C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16666 6.24984L4.26342 6.15307C4.68606 5.73043 4.73361 5.06133 4.37499 4.58317C4.01637 4.10501 4.06392 3.43591 4.48656 3.01327L4.58332 2.9165",
    stroke: "#1C274C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0834 6.24984L12.1802 6.15307C12.6028 5.73043 12.6504 5.06133 12.2917 4.58317C11.9331 4.10501 11.9807 3.43591 12.4033 3.01327L12.5001 2.9165",
    stroke: "#1C274C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCup);
export default __webpack_public_path__ + "static/media/cup.244150bcaabb137c97a6ac2bc4561687.svg";
export { ForwardRef as ReactComponent };